import { render, staticRenderFns } from "./DirectionsPersonal.vue?vue&type=template&id=3223fbd6"
import script from "./DirectionsPersonal.vue?vue&type=script&lang=js"
export * from "./DirectionsPersonal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports